
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/account/store';
import TermsConditions from '~/components/terms-conditions/terms-conditions.vue';

@Component({
	components: {
		TermsConditions,
	},
})
export default class TermsConditionPage extends Vue {
	mounted() {
		Store.commit.register.setStep(null);
	}

	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');
}
